/**
 * Cost type + Hide referrer rows. Extracted from BinomCampaignConfigTab to
 * stay under the per-file line budget.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import type { BinomCampaignMetaDraft } from '../../../binom-flow-draft.types';
import BinomCampaignFormRow from '../BinomCampaignFormRow';
import BinomCostInput from './BinomCostInput';
import BinomHideReferrerInput from './BinomHideReferrerInput';

export interface BinomCostHideRowsProps {
  meta: BinomCampaignMetaDraft;
  patchCampaignMeta: (m: (d: BinomCampaignMetaDraft) => void) => void;
}

const BinomCostHideRows: FC<BinomCostHideRowsProps> = ({
  meta,
  patchCampaignMeta,
}) => (
  <>
    <BinomCampaignFormRow label="Cost type">
      <BinomCostInput
        costModel={meta.costModel}
        amount={meta.amount}
        currency={meta.currency}
        isAuto={meta.isAuto}
        onChange={(p) =>
          patchCampaignMeta((d) => {
            if (p.costModel !== undefined) d.costModel = p.costModel;
            if (p.amount !== undefined) d.amount = p.amount;
            if (p.currency !== undefined) d.currency = p.currency;
            if (p.isAuto !== undefined) d.isAuto = p.isAuto;
          })
        }
      />
    </BinomCampaignFormRow>
    <BinomCampaignFormRow label="Hide referrer">
      <BinomHideReferrerInput
        type={meta.hideReferrerType}
        domain={meta.hideReferrerDomain}
        onChange={(p) =>
          patchCampaignMeta((d) => {
            if (p.hideReferrerType !== undefined)
              d.hideReferrerType = p.hideReferrerType;
            if (p.hideReferrerDomain !== undefined)
              d.hideReferrerDomain = p.hideReferrerDomain;
          })
        }
      />
    </BinomCampaignFormRow>
  </>
);

export default BinomCostHideRows;
